import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, ChevronDown, ChevronUp } from "lucide-react";

const POINTS = [
  ["Credits are NOT money.", "They are digital utility credits that can only be used within the Pickle Bullpen Platform."],
  ["Credits are NOT an investment.", "You are not purchasing an asset, security, or financial product."],
  ["Credits have NO guaranteed value.", "Any displayed dollar equivalency is for reference only and may change."],
  ["Redemption is NOT guaranteed.", "The ability to convert Credits to cash or cash equivalents is limited, conditional, and subject to approval, fees, delays, and restrictions."],
  ["Bonus Credits are promotional.", "They may have reduced value, limited use, expiration dates, or no cash redemption value."],
  ["Credits may expire.", "Unused Credits may be removed after inactivity or according to Platform rules."],
  ["The Platform may change the system.", "Pickle Bullpen may modify pricing, redemption rates, fees, and rules at any time."],
  ["You agree not to misuse the system.", "Any attempt to exploit, manipulate, or abuse the system may result in account suspension and loss of Credits."],
  ["You accept all risks associated with use.", "You understand that Credits are provided for convenience and participation within the Platform and are used at your own discretion."],
];

export const CreditDisclaimer = ({ agreed, onChange, ackDate }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="border border-amber-500/40 bg-amber-500/5 p-4 mb-4" data-testid="credit-disclaimer-box">
      <button data-testid="disclaimer-toggle" onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-2 text-left">
        <span className="flex items-center gap-2 text-[11px] font-black uppercase tracking-widest text-amber-400">
          <ShieldAlert className="w-4 h-4" /> Credit Disclaimer &amp; User Acknowledgment
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-zinc-500" /> : <ChevronDown className="w-4 h-4 text-zinc-500" />}
      </button>
      {open && (
        <div className="mt-3 max-h-48 overflow-y-auto space-y-2 text-xs text-zinc-400 pr-2" data-testid="disclaimer-text">
          <p className="text-zinc-300">By creating an account, purchasing, or using Credits, you acknowledge and agree to the following:</p>
          {POINTS.map(([lead, rest]) => (
            <p key={lead}><b className="text-amber-300">{lead}</b> {rest}</p>
          ))}
          <p className="text-zinc-300">By clicking &ldquo;I Agree,&rdquo; you confirm that you understand and accept all terms above.</p>
        </div>
      )}
      <label className="flex items-start gap-2.5 mt-3 cursor-pointer select-none">
        <input type="checkbox" data-testid="disclaimer-checkbox" checked={agreed}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 w-4 h-4 accent-[#A3E635] shrink-0" />
        <span className="text-xs text-zinc-300">
          <b>I Agree</b> — I have read and accept the Credit Disclaimer &amp; User Acknowledgment and the{" "}
          <button type="button" data-testid="disclaimer-policy-link" onClick={() => navigate("/credit-policy")}
            className="text-pb-cyan underline hover:text-white">Platform Credit Policy</button>.
        </span>
      </label>
      {ackDate && (
        <div className="text-[10px] text-zinc-500 mt-2 pl-6" data-testid="disclaimer-accepted-on">
          ✓ Accepted on {new Date(ackDate).toLocaleDateString()}
        </div>
      )}
    </div>
  );
};
